import React from 'react';
import ReactDOM from 'react-dom/client';
import GrievanceFormApp from './GrievanceFormApp';

const ELEMENT_ID = 'scl-grievance-form';

class SCLGrievanceFormElement extends HTMLElement {
  constructor() {
    super();
    this.root = null;
  }

  connectedCallback() {
    // Prevent double initialization
    if (this.root) return;

    const siteId =
        globalThis.Liferay?.ThemeDisplay?.getScopeGroupId() ||
        this.dataset.siteId ||
        "0";
    
    this.root = ReactDOM.createRoot(this);
    this.root.render(
      <GrievanceFormApp siteId={siteId} />
    );
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, SCLGrievanceFormElement);
}

export default SCLGrievanceFormElement;
